var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 3.5C1 2.39543 1.89543 1.5 3 1.5H6.27924C6.70967 1.5 7.09181 1.77543 7.22792 2.18377L8.72574 6.67721C8.88311 7.14932 8.66938 7.66531 8.22427 7.88787L5.96701 9.0165C7.06925 11.4612 9.03878 13.4308 11.4835 14.533L12.6121 12.2757C12.8347 11.8306 13.3507 11.6169 13.8228 11.7743L18.3162 13.2721C18.7246 13.4082 19 13.7903 19 14.2208V17.5C19 18.6046 18.1046 19.5 17 19.5H16C7.71573 19.5 1 12.7843 1 4.5V3.5Z",
    stroke: "#94A3B8",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTel);
export default __webpack_public_path__ + "static/media/tel.78148a059ab2bcfe05e17e9ff621b956.svg";
export { ForwardRef as ReactComponent };